import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { SAMLIntegrationConfig } from '@dadohr/shared/domainTypes/integrations/saml';
import { FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toSAMLConfigDoc = generateToDocFn<SAMLIntegrationConfig>();

const COLLECTION = FS.samlIntegrationConfig;
const collection = () => store().collection(COLLECTION);

export const samlConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toSAMLConfigDoc
);
export const useSAMLConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(samlConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<SAMLIntegrationConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,

            // idpSsoUrl: '',
            // idpIssuer: '',
            // x509Certificate: '',

            idpMetadata: ''
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeSAMLConfig = (orgId: string) => {
  // TODO cleanup up SSO settings on org
  return collection().doc(orgId).delete();
};
